module.exports = __webpack_public_path__ + "img/placeholder_sc1.e8504fd4.png";